module.exports = __webpack_public_path__ + "img/xen3.57e5fe85.png";